export enum ScrollingContainer {
  documentPrepare = 'document-prepare',
  editor = 'editor',
  quickEditAndToken = 'quickEditAndToken'
}
